import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EmployeeAverageAgeListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialEmployeeAverageAgeList } from '../../logics/employeeAverageAge/createInitialEmployeeAverageAgeList';

/**
 * 社員の平均年齢に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useEmployeeAverageAge = (args: HooksArgument) => {
  const [employeeAverageAgeList, setEmployeeAverageAgeList] = useState<
    EmployeeAverageAgeListType[]
  >(createInitialEmployeeAverageAgeList(args));

  const selectedEmployeeAverageAgeList = useMemo(() => {
    return employeeAverageAgeList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [employeeAverageAgeList]);

  // チェック状態更新処理
  const updateIsCheckedEmployeeAverageAgeList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = employeeAverageAgeList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setEmployeeAverageAgeList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [employeeAverageAgeList]
  );

  // 求人件数更新処理
  const updateEmployeeAverageAgeListJobCount = useCallback(
    (requirementsJobCountList: JobCountDetailResponse[] | undefined) => {
      setEmployeeAverageAgeList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(requirementsJobCountList, item.value),
        }))
      );
    },
    []
  );

  return {
    employeeAverageAgeList,
    selectedEmployeeAverageAgeList,
    updateIsCheckedEmployeeAverageAgeList,
    updateEmployeeAverageAgeListJobCount,
  };
};
